import { errorNotifier, successNotifier } from "../../../components/NotificationHandler";
import http, { AUTH_ROUTES } from "../../../services/api";

export const fetchStreetsData = async (setStreetsData, setLoadingStreets) => {
  try {
    setLoadingStreets(true);
    const { data } = await http.get("/user/house");

    const transformedData = data?.result?.data?.houses?.reduce((acc, house) => {
      const streetId = house?.streetId?._id;
      const streetName = house?.streetId?.streetName;
      const houseId = house?._id;

      if (streetId && streetName && Array.isArray(house.estate)) {
        if (!acc.streets[streetId]) {
          acc.streets[streetId] = { 
            streetName, 
            houses: [],
            uniqueHouses: new Set() // Track unique house numbers
          };
        }
        
        // Loop through all estates for this house
        house.estate.forEach(est => {
          if (est?.houseNumber && !acc.streets[streetId].uniqueHouses.has(est.houseNumber)) {
            acc.streets[streetId].houses.push({
              number: est.houseNumber,
              id: houseId
            });
            acc.streets[streetId].uniqueHouses.add(est.houseNumber);
          }
        });
      }

      return acc;
    }, { streets: {} });

    // Clean up the data structure by removing the uniqueHouses Set
    Object.keys(transformedData.streets).forEach(streetId => {
      delete transformedData.streets[streetId].uniqueHouses;
    });

    setStreetsData(transformedData);
    setLoadingStreets(false);
  } catch (error) {
    errorNotifier(error.response?.data?.result?.message || "Failed to load street data.");
    console.error("Error fetching streets data:", error);
    setLoadingStreets(false);
  }
};



export const signupTenant = async (payload, setLoading) => {
  try {
    setLoading(true);
    const { data } = await http.post(AUTH_ROUTES.SIGNUP, payload);

    if (data.result.success) {
        successNotifier(data.result?.message);
        return true; 
    } else {
      errorNotifier("Signup failed. Please try again.");
      return false; 
    }
  } catch (e) {
    if (e?.response?.data?.errors) {
        const errorMessages = e.response.data.errors
          .map((error) => error.msg)
          .join(", ");
        errorNotifier(errorMessages || "Signup failed with errors.");
      } else {
        errorNotifier("Please check your network connection!!!");
      }
  } finally {
    setLoading(false);
  }
};
